import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import Help from '../../Common/Help/Help';
import deleteIcon from '../../../images/icons/delete.svg';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

const DragHandle = SortableHandle(() => <div className="sort-handle">::</div>);

const SortableItem = SortableElement(({index, value, handleSortableInputs, deleteRow}) => {
	return (
		<tr>
			<td className="text-center">
				{value.delete && (
					<DragHandle />
				)}  
			</td>
			<td>
                <div className={"showtix-form__group " + (value.validation.name === false ? 'showtix-form__error' : '')}>
					<div className="showtix-form__input">
						<input 
							className="showtix-input"
							type="text"
							object="prices"
							name="name"
							id={value.id}
							value={value.name}
                            onChange={handleSortableInputs}	
                            validation="(^(?!\s*$).+)"
						/>
					</div>
				</div>	
			</td>
			<td>
                <div className={"showtix-form__group " + (value.validation.price === false ? 'showtix-form__error' : '')}>
					<div className="showtix-form__input showtix-form__money">
						<input
							className="showtix-input"
							type="number"
							min="0.00"
							step="0.50"
							object="prices"
							name="price"
							id={value.id}
							value={value.price} 
							onChange={handleSortableInputs}
							validation="(^\$?\d+((,\d{3})+)?(\.\d+)?$)"
						/>
					</div>
				</div>	
			</td>
            <td className="text-right">
				{value.delete && 
					<button
                        className="showtix-button showtix-button__simple"
                        object="prices"
						id={value.id}
						onClick={deleteRow}
					>
						<img 
							className="delete-icon" 
							src={deleteIcon} 
							alt="delete icon" 
						/>
					</button>
				}
			</td>
		</tr>
	);
});

const SortableList = SortableContainer(({items, handleSortableInputs, deleteRow}) => {
	return (
		<tbody>
			{items.map((value, index) => (
				<SortableItem 
					key={`item-${index}`} 
					index={index} 
					value={value}
					handleSortableInputs={handleSortableInputs}
					deleteRow={deleteRow} 
				/>
			))}
		</tbody>
	);
});

class FlexpassPricing extends Component {

	render() { 
		return ( 
			<div className="showtix-section showtix-background__primary-1">
				<div className="container">
					<div className="row">
						<div className="col-12 col-lg-9">
							<h1>{strings.title}</h1>
							<div className="row">
								<div className="col-12">
									<div className="showtix-form__group">
										<div className="table-responsive">
											<table className="showtix-table" id="prices" width="100%">
												<thead>
													<tr>
														<th></th>
														<th>{strings.table.titleName}</th>
														<th className="text-center">{strings.table.titlePrice}</th>
                                                        <th style={{ width: 50 }}></th>
													</tr>
												</thead>
												<SortableList 
													items={this.props.flexpassDetails.prices}
                                                    onSortEnd={this.props.onSortEnd}
                                                    onSortStart={this.props.onSortStart}
													handleSortableInputs={this.props.handleSortableInputs}
                                                    deleteRow={this.props.deleteRow}
                                                    lockToContainerEdges={true}
                                                    lockAxis= 'y'
													useDragHandle={true} />
											</table>
										</div>
									</div>
								</div>
							</div>
						</div>

						{ strings.helps &&
							<div className="col-12 col-lg-3">
								{strings.helps.map((help, i) =>
									<Help help={help} key={i} /> 
								)}
							</div>	
						}
					</div>
				</div>
			</div>
		)
	}
}

FlexpassPricing.propTypes = {
    flexpassDetails: PropTypes.object,
    onSortEnd: PropTypes.func,
    onSortStart: PropTypes.func,
    handleSortableInputs: PropTypes.func,
    deleteRow: PropTypes.func,
}
 
export default FlexpassPricing;


// WEBPACK FOOTER //
// ./src/components/CreateFlexpass/FlexpassPricing/FlexpassPricing.js